var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 19,
    viewBox: "0 0 25 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.901267 10.5124H20.9571L14.3184 17.1511C13.9665 17.5031 13.9665 18.0736 14.3184 18.4255C14.4942 18.6017 14.7249 18.6896 14.9556 18.6896C15.1863 18.6896 15.4171 18.6017 15.5928 18.4255L23.77 10.2483C24.1219 9.89637 24.1219 9.32587 23.77 8.97393L15.5933 0.796734C15.2418 0.44479 14.6704 0.44479 14.3189 0.796734C13.9669 1.14868 13.9669 1.71918 14.3189 2.07113L20.9576 8.70985H0.901267C0.403767 8.70985 0 9.11362 0 9.61112C0 10.1086 0.403317 10.5124 0.901267 10.5124Z",
    fill: "url(#paint0_linear_1685_7783)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1685_7783",
    x1: 12.017,
    y1: 0.532776,
    x2: 12.017,
    y2: 18.6896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF224C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9129FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.e80247e3999519f63204fb040e0eb26d.svg";
export { ForwardRef as ReactComponent };